import { effectsSymbol } from './symbols';
import { createEffect } from './create-effect';
function setEffects(state, cb) {
    state[effectsSymbol].push(cb);
}
const useEffect = createEffect(setEffects);
export { setEffects, useEffect };
